(() => {
  const account=document.getElementById('header-account'),cart=document.getElementById('header-cart'),badge=document.getElementById('header-cart-count');
  const copy=JSON.parse(document.getElementById('ch-quote-copy').textContent);
  const words=()=>copy[document.documentElement.lang]||copy.en;
  function visit(selection){
    closeMenu();
    if(document.getElementById('o-app')&&!document.getElementById('o-app').hidden){if(selection)document.getElementById('o-cbtn').click();else document.getElementById('o-q').focus();return;}
    const target=chPageUrl('commander');
    const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)target.searchParams.set('preview_theme_id',preview);
    if(selection)target.searchParams.set('panier','1');
    location.assign(target.href);
  }
  function sync(){
    let count=0;try{count=Object.keys(JSON.parse(sessionStorage.getItem('ch_demo_cart_v1')||'{}').cart||{}).length;}catch{}
    document.getElementById('header-account-label').textContent=words().guest_account;account.setAttribute('aria-label',words().guest_account);account.title=words().guest_account;
    cart.querySelector('.header-cart-text').textContent=words().quote;cart.setAttribute('aria-label',words().selection);cart.title=words().selection;badge.textContent=String(count);badge.hidden=!count;
    document.getElementById('header-mobile-lang').value=LANG;
  }
  account.addEventListener('click',()=>visit(false));cart.addEventListener('click',()=>visit(true));
  const counter=document.getElementById('o-cnt');if(counter)new MutationObserver(sync).observe(counter,{childList:true});
  new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
  document.getElementById('header-mobile-lang').addEventListener('change',event=>setLang(event.target.value));
  if(new URLSearchParams(location.search).get('panier')==='1'&&document.getElementById('o-app')&&!document.getElementById('o-app').hidden)document.getElementById('o-cbtn').click();
  sync();
})();
